// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"b452a10b","176":"162c8ddd","760":"51aad049","818":"eb559c62","989":"04465a6d"}[chunkId] + ".chunk.js";
};